import { Icon, IconBox } from "@proda-ai/ui-kit";
import type {
    IconNameBrand,
    IconNameGeneric,
    IconProp,
} from "@proda-ai/ui-kit";
import Typography from "@/ui/atoms/Typography";
import Box from "@/ui/atoms/Box";
import type { BoxProps } from "@/ui/atoms/Box";

export type BannerProps = BoxProps & {
    dismiss: () => void;
    content: string;
    icon: {
        icon: IconProp<IconNameGeneric, IconNameBrand>;
        color?: string;
    };
};

const Banner = ({ dismiss, content, icon, ...props }: BannerProps) => {
    const { sx, ...otherProps } = props;

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px 8px",
                width: "100%",
                ...sx,
            }}
            {...otherProps}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                }}
            >
                <IconBox>
                    <Icon icon={icon.icon} color={icon.color} size="sm" />
                </IconBox>
                <Typography variant="h5">{content}</Typography>
            </Box>
            <IconBox style={{ cursor: "pointer" }} onClick={dismiss}>
                <Icon icon="xmark" color="var(--proda-black)" />
            </IconBox>
        </Box>
    );
};

export default Banner;
